// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid___2DgMj","mix":"mix___3e-jN","title":"title___1Jgkb"};